// @flow
import * as React from "react";
import styled from "styled-components";
import { Link as RouterLink, NavLink as RouterNavLink } from "react-router-dom";
import { NEWS_LINK } from "./fetch";
import withData from '../withData';

const Button = styled.button`
  display: inline;
  padding: 0;
  border: none;
  background: none;
  text-decoration: underline;
  cursor: pointer;
`;

const ExternalLink = styled.a`
  display: inline;
  padding: 0;
  border: none;
  background: none;
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  to: string,
  children?: React.Node,
  className?: string,
  onClick?: () => mixed | void,
  target?: string,
  exact?: boolean,
  rel?: string,
};

export const isWebApp = () => {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const Link = (props: Props) => (
  <RouterLink
    to={props.to}
    className={props.className}
    onClick={props.onClick || null}
    target={isWebApp() ? null : props.target}
    rel={props.rel}
  >
    {props.children}
  </RouterLink>
);

export const NavLink = (props: Props) => (
  <RouterNavLink
    to={props.to}
    className={props.className}
    onClick={props.onClick || null}
    target={props.target}
    exact={props.exact}
  >
    {props.children}
  </RouterNavLink>
);

export const OptionalLink = (props) =>
  !!props.to ? (
    <Link {...props} />
  ) : !!props.href ? (
    <ExternalLink {...props} />
  ) : (
    <Button {...props} />
  );

export const getCompleteLocale = (locale: string | undefined) => {
  switch (locale) {
    case "vn":
      return "vi_VN";
    case "ph":
      return "fi_PH";
    case "th":
      return "th_TH";
    case "id":
      return "id_ID";
    case "hi":
      return "hi_HI";
    default:
      return "en_EN";
  }
};

export const NewsLink = withData({
  optional: ["profile"],
})(({ to = "", ...props }) => {
  return NEWS_LINK ? (
    <ExternalLink
      href={`${NEWS_LINK}${to}?lang=${getCompleteLocale(props.profile && props.profile.locale)}`}
      {...props}
    />
  ) : (
    <Link to={`/news/${to}`} {...props} />
  );
});



// WEBPACK FOOTER //
// ./src/components/common/Link.js